module.exports = __webpack_public_path__ + "static/media/list.20571d5f.svg";